import { IconButton, Snackbar } from "@mui/material"; // ../../pages/Loans/style
import CloseIcon from "@mui/icons-material/Close";
import { errorSnackBar, snackbarStyle } from "../../pages/Loans/v1/style";

import { SnackbarProps } from "./snackbar.types";
import InfoErrorIcon from '../../assets/InfoErrorIcon.svg'
import CheckedCircle from '../../assets/CheckedCircle.svg'


const SnackBar = (props: SnackbarProps) => {
    const { message, handleClose} = props
    const style =
    message === "failed" ? errorSnackBar : snackbarStyle;


    return (
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={true}
        onClose={handleClose}
        autoHideDuration={3000}
        ContentProps={{ style }}
        message={
          <div className="flex-display" style={{ alignItems: "center" }}>
            <img
              src={
                message === "failed"
                  ? InfoErrorIcon
                  : CheckedCircle
              }
              className="mr-12"
              style={{ display: "block" }}
            />
            <span>
              {message ? message : "Failed to save data"}
            </span>
          </div>
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(event) => handleClose(event, "manual")}
            style={{ padding: 4 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    );
  };

  export default SnackBar